// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"627cefe1","492":"16bf8e42"}[chunkId] + ".chunk.js";
};